/**
 * External dependencies
 */
import { map, flatten } from 'lodash';

/**
 * Inernal dependencies
 */
import getLayouts from './get-all-layouts';

export default (state) => {
	return flatten(
		map(getLayouts(state), (layout) => {
			return map(layout.items, (item) => {
				return { layoutId: layout.id, ...item };
			});
		}),
	);
};
